<template>
  <v-select
    :items="typeOptions"
    :label="typeLabel"
    v-model="selectedTypeUUID"
    item-text="name"
    item-value="uuid"
    class="mt-5"
    color="primary"
    :rules="rules"
  />
</template>

<script>
import api from "@/utils/api";

export default {
  name: "ModelTypeSelector",
  props: [
    "model_type_uuid",
    "initial_data",
    "custom_label",
    "select_default",
    "rules",
  ],
  data: () => ({
    typeOptions: [],
    groupSearch: "",
  }),
  created() {
    if (this.initial_data) {
      this.typeOptions.push(this.initial_data);
      this.selectedTypeUUID = this.initial_data.uuid;
    }
    api.modelTypeAutocomplete().then((resp) => {
      this.typeOptions = resp.data;
    });
  },
  computed: {
    typeLabel: function () {
      return this.custom_label
        ? this.custom_label
        : this.$t("components.selectors.modelTypeSelector.type");
    },
    selectDefault: function () {
      return !!this.select_default;
    },
    selectedTypeUUID: {
      get: function () {
        return this.model_type_uuid;
      },
      set: function (value) {
        this.$emit("update:model_type_uuid", value);
      },
    },
  },
};
</script>
